import { hasBanner } from '@asset/themes/config';
import loadable from '@loadable/component';
import styled from '@emotion/styled';

const Footer = loadable(() => import('@com/footer/Footer'));
const Header = loadable(() => import('@com/header/Header'));
const LiveAuction = loadable(() => import('@com/layouts/home-6/LiveAuction'));
const PopularCollection = loadable(
  () => import('@com/layouts/home-6/PopularCollection')
);
const SliderStyle3 = loadable(() => import('@com/slider/SliderStyle3'));

const Home = styled.div`
  background-color: var(--bg-section2);
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

function Home06(): JSX.Element {
  return (
    <Home className="home-6">
      <Header />
      <div className="d-flex flex-column flex-grow-1">
        {hasBanner && <SliderStyle3 />}
        <PopularCollection />
        <LiveAuction />
      </div>
      <Footer />
    </Home>
  );
}

export default Home06;
